import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { ToastService } from 'projects/shared/core/services/toast.service';
import { RmsUserGuideService } from './rms-user-guide.service';

@Injectable()
export class UserGuideActivationGuard implements CanActivate {
  
  constructor(
    private _toastService: ToastService,
    private _userGuideService: RmsUserGuideService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this._userGuideService.downloadUserGuide(route.params.id)
    .catch((error) => this._toastService.showError(error));
    return false;
  }

}
